export enum CONTENT_TEMPLATES {
    /**
     * https://app.lokalise.com/project/971428945b55f3d6334c27.85957847/?k=13452354
     */
    ADMIN_TEMPLATE = 'ADMIN_TEMPLATE',
    /**
     * https://app.lokalise.com/project/971428945b55f3d6334c27.85957847/?k=13452631
     */
    DELETE_SUCCESS = 'CONTENT_DELETE_SUCCESS',
    /**
     * https://app.lokalise.com/project/971428945b55f3d6334c27.85957847/?k=13453697
     */
    TEMPLATE_DELETE = 'TEMPLATE_DELETE',
    /**
     * https://app.lokalise.com/project/971428945b55f3d6334c27.85957847/?k=13453698
     */
    TEMPLATE_DELETE_DESCRIPTION = 'TEMPLATE_DELETE_DESCRIPTION',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=691104503
     */
    EMPTY_STATE_TITLE = 'BROADCAST_TEMPLATES.EMPTY_STATE_TITLE',
}
